import { render, staticRenderFns } from "./unauthorize.vue?vue&type=template&id=3e7c396c&scoped=true&lang=pug&"
import script from "./unauthorize.vue?vue&type=script&lang=ts&"
export * from "./unauthorize.vue?vue&type=script&lang=ts&"
import style0 from "./unauthorize.vue?vue&type=style&index=0&id=3e7c396c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7c396c",
  null
  
)

export default component.exports